import React from 'react';

const Input = ({ type, id, name, value, onChange, label, disabled, required }) => {
    return (
        <div>
            <label htmlFor={id}>{label}:</label>
            <input
                type={type}
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                required={required}
            />
        </div>
    );
};

export default Input;
